import React from 'react';

import { StyledSectionGrid, StyledRowTitle } from './styles';

const Row: React.FC<{
  name: React.ReactNode;
  children: React.ReactNode;
  id?: string;
  // `id` lands on the label cell, so it cannot scope the value — they are sibling grid items.
  valueTestId?: string;
}> = ({ name, children, id, valueTestId }): React.ReactElement => (
  <>
    <StyledSectionGrid item container xs={3} id={id}>
      <StyledRowTitle>{name}</StyledRowTitle>
    </StyledSectionGrid>
    <StyledSectionGrid item container xs={9} paddingLeft="8px" data-testid={valueTestId}>
      {children}
    </StyledSectionGrid>
  </>
);
export default Row;
